import { render, staticRenderFns } from "./DoctorPatientWard.vue?vue&type=template&id=6b25d150&"
import script from "./DoctorPatientWard.vue?vue&type=script&lang=js&"
export * from "./DoctorPatientWard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports